import type { PropsWithChildren } from 'react';
import { useAssetState } from '../contexts';
import { LabelReveal } from './LabelReveal';

/**
 * The TimecodeReveal component transitions its children with a fade in.
 */
export function TimecodeReveal({ children }: PropsWithChildren) {
  const assetState = useAssetState();

  return (
    <LabelReveal
      visible={
        assetState === 'complete' ||
        assetState === 'transcribing' ||
        assetState === 'transcribing-processing' ||
        assetState === 'validating-brand'
      }
    >
      {children}
    </LabelReveal>
  );
}
